export default "__VITE_ASSET__BoQnNws2__"